import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.mainElement = document.querySelector('main')

    if (this.mainElement) {
      this.syncHeight()
      this.setupResizeObserver()
    }
  }

  disconnect() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect()
    }
  }

  syncHeight = () => {
    const height = this.mainElement.offsetHeight
    this.element.style.height = `${height}px`
  }

  setupResizeObserver = () => {
    this.resizeObserver = new ResizeObserver(() => {
      this.syncHeight()
    })
    this.resizeObserver.observe(this.mainElement)
  }
}
